import styled, { CSSProperties } from 'styled-components';

interface VariantNakedImageProps {
    image: string;
    style?: CSSProperties;
    className?: string;
}

export const VariantNakedImage = (props: VariantNakedImageProps) => {
    return (
        <S_VariantNakedImage className={props.className} style={props.style}>
            {props.image && <S_Image $src={props.image} />}
        </S_VariantNakedImage>
    );
};

const S_VariantNakedImage = styled.div`
    width: 40px;
    height: 40px;
`;

const S_Image = styled.div<{ $src: string }>`
    filter: drop-shadow(2px 0 0 white) drop-shadow(-2px 0 0 white) drop-shadow(0 2px 0 white)
        drop-shadow(0 -2px 0 white) drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.1));
    border-radius: 8px;
    width: 40px;
    height: auto;
    background-size: contain;
    background-image: url(${(props) => props.$src});
`;
